import React, {PropsWithChildren} from 'react';
import './textEditorButtonWrapper.styles.scss';

function TextEditorButtonWrapper<T>({children}: PropsWithChildren<T>): JSX.Element {
    return <div className="c-textEditorButtonWrapper">{children}</div>;
}

export default TextEditorButtonWrapper;
